function triggerObjectLink() {
  const isPresent = document.querySelector(".floorplan-object");
  if (!isPresent) {
    return;
  }

  const objects = document.querySelectorAll(".floorplan-object");

  objects.forEach((object) => {
    object.addEventListener("click", function () {
      const url = object.dataset.url;
      window.location.href = url;
    });
  });
}

export { triggerObjectLink };

function updateFloorSVG() {
  const isPresent = document.querySelector(".svg-floor-data");
  if (!isPresent) {
    return;
  }

  const targetObjects = document.querySelectorAll(".floorplan-object");

  targetObjects.forEach((target) => {
    const targetID = target.getAttribute("id");
    const source = document.querySelector(
      `.svg-floor-data__single[id='${targetID}']`
    );

    const status = source.getAttribute("data-status");
    const url = source.getAttribute("data-url");

    target.dataset.status = status;
    target.dataset.url = url;
  });
}

export { updateFloorSVG };

function triggerForm() {
  const isPresent = document.querySelector(".js-open-object-form");
  if (!isPresent) {
    return;
  }

  const formWrapper = document.querySelector(".object-form-overlay");
  const triggers = document.querySelectorAll(".js-open-object-form");
  const close = document.querySelector(".js-close-object-form");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      formWrapper.classList.add("visible");

      const objTitle = trigger.dataset.objectTitle;
      const objID = trigger.dataset.objectId;
      const prjID = trigger.dataset.projectId;
      const itemID = trigger.dataset.itemId;

      const targetTitle = document.querySelector(".js-form-object-title input");
      const targetID = document.querySelector(".js-form-object-id input");
      const targetPrj = document.querySelector(".js-form-project-id input");
      const targetItemID = document.querySelector(".js-form-item-id input");

      targetTitle.value = objTitle;
      targetID.value = objID;
      targetPrj.value = prjID;
      targetItemID.value = itemID;
    });

    close.addEventListener("click", function () {
      formWrapper.classList.remove("visible");
    });

    window.onkeydown = function (event) {
      if (event.keyCode == 27) {
        formWrapper.classList.remove("visible");
      }
    };
  });
}

export { triggerForm };
